// The site's JavaScript, bundled by esbuild into app/assets/builds/application.js (see esbuild.config.mjs). It loads as
// a classic script in the <head>, so the libraries below are globals ($, jQuery, _, Foundation, Masonry, Modernizr):
// ./globals.js makes the ones from npm globals, and the files in ./vendor run in the page's global scope, as they did
// under Sprockets. They load in this order.
//
// Views have no inline scripts or on* attributes (only the development-only pages in app/views/dev, which don't use
// this layout or bundle): a page's behaviour lives in a file here, found by a class or data attribute (e.g.
// data-masonry-grid). Because this runs in the <head> before the page exists, those files listen on document (clicks,
// changes and submits bubble up to it) or wait for DOMContentLoaded before looking for elements. Error reports only
// count errors thrown in our bundles (error_reporting.js).
import './modernizr'
import './globals'
import './rails_ujs'
import './foundation'
import './dropdown_menus'
import './lazy_images'
import './hide_broken_images'
import './sized_figure_rows'
import './masonry_grids'
import './passkeys'
import './analytics'
import './android_test_notice'
import './dark_mode'
import './figure_lists'
import './skip_empty_fields'
import './game_feature_form'
import './back_forward_cache'

// Foundation reads its data-attribute prefix from a meta tag's CSS font-family, which some browsers (and font-override
// settings) report as their default font, e.g. "Times New Roman"; the invalid selectors that makes stopped every
// Foundation plugin, menus included. We use no prefix, so say so directly.
Foundation.global.namespace = '';

// Foundation's top bar closes every open dropdown on any window resize, and mobile browsers fire resize when the
// address bar shows or hides as you scroll, so menus closed themselves mid-scroll. Only react when the width changes.
(function(topbar) {
  var resize = topbar.resize, lastWidth = null;
  topbar.resize = function() {
    if (window.innerWidth === lastWidth) { return; }
    lastWidth = window.innerWidth;
    return resize.apply(this, arguments);
  };
})(Foundation.libs.topbar);

$(function(){
  // Where the main input can't hover (phones, tablets), top bar dropdowns open and close on tap instead of on hover
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
    $('[data-topbar]').attr('data-options', 'is_hover: false');

    // Menu titles only open and close their menus (Foundation handles that); they never follow their links, whose
    // destinations are all in the menus themselves. Foundation only blocks the link when the tap lands on the link
    // element itself, not on content inside it like the account menu's avatar and username.
    document.addEventListener('click', function(e) {
      if (e.target.closest && e.target.closest('.top-bar-section li.has-dropdown > a')) { e.preventDefault(); }
    }, true);
  }
  $(document).foundation();
});
